import { SearchFiltersUtil } from '../../../../utils/search_filters_util';
import { addToList, removeFromList } from '../../../../utils/requests/list_requests';

const ListHashMixin = {
  favoriteMagicId: 1000,
  completedMagicId: 1001,
  verifiedMagicId: 1003,
  getListItemsHash(my) {
    if (my) {
      return this.state.myListItems;
    }
    return this.state.usersListItems;
  },
  createListItemsHash(my) {
    if (my) {
      this.state.myListItems = {};
      return this.state.myListItems;
    }
    this.state.usersListItems = {};
    return this.state.usersListItems;
  },
  getListIdsInHash(my) {
    const listItems = this.getListItemsHash(my);
    return listItems ? Object.keys(listItems) : [];
  },
  updateListItemsHash(my) {
    if (my) {
      this.setState(prevState => ({ myListItems: prevState.myListItems }));
    } else {
      this.setState(prevState => ({ usersListItems: prevState.usersListItems }));
    }
  },
  itemsInListOfType(my, listId, type) {
    let listItems = this.getListItemsHash(my);
    if (!listItems) {
      listItems = this.createListItemsHash(my);
    }
    let items = listItems[listId];
    if (!items) {
      listItems[listId] = {};
      items = listItems[listId];
    }
    let itemsOfType = items[type];
    if (!itemsOfType) {
      items[type] = {};
      itemsOfType = items[type];
    }
    return itemsOfType;
  },
  hasItemsInList(my, listId) {
    const trailItems = this.itemsInListOfType(my, listId, 'trail');
    if (Object.keys(trailItems).length > 0) {
      return true;
    }
    const trackItems = this.itemsInListOfType(my, listId, 'track');
    if (Object.keys(trackItems).length > 0) {
      return true;
    }
    const mapItems = this.itemsInListOfType(my, listId, 'map');
    if (Object.keys(mapItems).length > 0) {
      return true;
    }
    return false;
  },
  isItemInList(my, listId, type, objectId) {
    const items = this.itemsInListOfType(my, listId, type);
    return Object.prototype.hasOwnProperty.call(items, objectId);
  },
  getListItemInList(my, listId, type, objectId) {
    const items = this.itemsInListOfType(my, listId, type);
    return items[objectId];
  },
  addItemToList(my, listId, type, objectId, listItem) {
    const items = this.itemsInListOfType(my, listId, type);
    if (listItem) {
      items[objectId] = {
        id: listItem.id,
        order: listItem.order
      };
    } else {
      items[objectId] = null;
    }
    this.updateListItemsHash(my);
  },
  removeItemFromList(my, listId, type, objectId) {
    const items = this.itemsInListOfType(my, listId, type);
    if (!Object.prototype.hasOwnProperty.call(items, objectId)) return;
    delete items[objectId];
    this.updateListItemsHash(my);
  },
  // These functions depend on ListItemRequestMixin
  addListItem(userId, listId, type, objectId) {
    const my = !userId;
    this.addItemToList(my, listId, type, objectId);
    return addToList(listId, type, objectId, userId)
      .then(addedListItem => {
        this.addItemToList(my, listId, addedListItem.type, addedListItem.objectId, addedListItem);
        if (this.messagingChannel && this.isItemFavorited) {
          const isFavorite = this.isItemFavorited(type, objectId);
          this.messagingChannel.publish('listItem.favorited', {
            type,
            objectId,
            isFavorite
          });
        }
        return addedListItem;
      })
      .catch(error => {
        console.error(error);
        this.removeItemFromList(my, listId, type, objectId);
        return error;
      });
  },
  removeListItem(userId, listId, type, objectId, listItem) {
    const my = !userId;
    this.removeItemFromList(my, listId, type, objectId);
    return removeFromList(listId, listItem.id, userId)
      .then(removedListItem => {
        this.removeItemFromList(my, listId, removedListItem.type, removedListItem.objectId);
        if (this.messagingChannel && this.isItemFavorited) {
          const isFavorite = this.isItemFavorited(type, objectId);
          this.messagingChannel.publish('listItem.favorited', {
            type,
            objectId,
            isFavorite
          });
        }
        return removedListItem;
      })
      .catch(error => {
        console.error(error);
        this.addItemToList(my, listId, type, objectId, listItem);
        return error;
      });
  },
  toggleInList(userId, listId, type, objectId) {
    const my = !userId;
    const listItem = this.getListItemInList(my, listId, type, objectId);
    if (listItem) {
      this.removeListItem(userId, listId, type, objectId, listItem).then(removedListItem =>
        this.updateResultsFromListHash('remove', removedListItem)
      );
    } else {
      this.addListItem(userId, listId, type, objectId).then(addedListItem => this.updateResultsFromListHash('add', addedListItem));
    }
  },
  // Handlers for receiving message from another component, notifying that a listItem has been added/removed
  listItemAdded(listItem) {
    const my = true;
    this.addItemToList(my, listItem.listId, listItem.type, listItem.objectId, listItem);
    this.updateResultsFromListHash('add', listItem);
  },
  listItemRemoved(listItem) {
    const my = false;
    this.removeItemFromList(my, listItem.listId, listItem.type, listItem.objectId);
    this.updateResultsFromListHash('remove', listItem);
  },
  // Updates fitlers/results in state based on list items added/removed
  updateResultsFromListHash(action, listItem) {
    const my = false;
    const { listId } = this.state;

    let { results } = this.state;
    if (results) {
      if (parseInt(listItem.listId) === parseInt(listId)) {
        // Add/Remove from results
        results = results.filter(result => result.objectID !== `${listItem.type}-${listItem.objectId}`);
        if (action === 'add' && listItem.object) {
          // Add object onto the front of results so it appears at the top of the search result list on explore pages
          // Note: an item (currently) can't be added to a list from the list SEO page
          results.unshift(listItem.object);
        }
      } else if (results.length > 0) {
        // Force results to trigger new render/state-change
        results[0].changed = new Date();
      }
    }

    const { filters } = this.state;
    if (filters) {
      const trailIds = Object.keys(this.itemsInListOfType(my, listId, 'trail'));
      SearchFiltersUtil.setFilter(filters, 'trailIds', trailIds);

      const trackIds = Object.keys(this.itemsInListOfType(my, listId, 'track'));
      SearchFiltersUtil.setFilter(filters, 'trackIds', trackIds);

      const mapIds = Object.keys(this.itemsInListOfType(my, listId, 'map'));
      SearchFiltersUtil.setFilter(filters, 'mapIds', mapIds);
    }

    if (results || filters) {
      const afterSetState = this.performSearch ? this.performSearch : () => {};
      this.setState(
        {
          filters,
          results
        },
        afterSetState
      );
    }
  },
  addList(listId, title, order) {
    const my = true;
    let listItems = this.getListItemsHash(my);
    if (!listItems) {
      listItems = this.createListItemsHash(my);
    }
    listItems[listId] = {};

    this.state.myLists.push({
      id: listId,
      title,
      order
    });
  }
};

export { ListHashMixin };
